export default "__VITE_ASSET__DIfZWw2Y__"